import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent, BaseService } from '@core';

@Component({
  selector: 'prox-how-to-import-users-doc',
  templateUrl: './how-to-import-users-doc.component.html',
  standalone: false,
  host: { class: 'flex flex-col flex-1 overflow-hidden' },
})
export class HowToImportUsersDocComponent extends BaseComponent {
  mdSrc = '/assets/docs/how-to-import-users.md';

  constructor(baseService: BaseService, route: ActivatedRoute) {
    super(baseService, route);
  }

  updateFromParams() {
    this.setTitle('Documents - How to Import Users');
    this.isPageReady = true;
  }
}
